<hr class="m-0 bg-secondary w-100 border-0 opacity-50" style="height: 1px;" />
<footer class="site-footer border-0">
  <div class="footer-container">

    <!-- Left Section: Dynamic Links & Note -->
    <div class="footer-left">
      <ul class="footer-links">
        @for (link of footer.footerLinks; track link.title) {
          <li>
            @if (link.alttext === 'Cookies') {
              <a class="optanon-show-settings cursor-pointer" data-ignore-geolocation="true" onclick="delete_cookie()">
                {{ link.title }}
              </a>
            }
            @else {
              <a [href]="link.url" [attr.title]="link.alttext">
                {{ link.title }}
              </a>
            }
          </li>
        }
      </ul>
      <!-- Dynamic Footer Note -->
      <span class="footer-copyright">{{ footer.footerNote }}</span>
    </div>

    <!-- Right Section: Social Icons Placeholder -->
    <div class="footer-right">
      <ul class="social-icons">
        <li>
          <a class="d-block" href="https://twitter.com/avaya" aria-label="X (Twitter)">
            <img src="/cs/cop/assets/images/svgs/twitter_x.svg" alt="Twitter X">
          </a>
        </li>
        <li>
          <a class="d-block" href="https://www.youtube.com/avaya" aria-label="YouTube">
            <img class="invert_color" src="/cs/cop/assets/images/svgs/youtube-brands.svg" alt="Youtube">
          </a>
        </li>
        <li>
          <a class="d-block" href="https://www.linkedin.com/company/avaya/" aria-label="LinkedIn">
            <img class="invert_color" src="/cs/cop/assets/images/svgs/linkedin-brands.svg" alt="LinkedIn">
          </a>
        </li>
      </ul>
    </div>
  </div>
</footer>